import React from "react";

const SectionHeader = ({
  title,

  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <div className="text-center flex flex-col items-center md:mb-12 mb-4">
      <h2 className="w-[85%] md:w-full  text-3xl md:text-4xl font-bold mb-4">{title}</h2>
      <p className="w-[90%] md:w-full font-medium md:font-normal text-base md:text-lg text-[#1C1D1F] max-w-3xl mx-auto">
        {description}
      </p>
    </div>
  );
};

export default SectionHeader;
